import Cookies from 'js-cookie';

enum Cookie {
  google = 'userGoogleToken',
  user = 'webUser',
  surveyInfo = 'surveyInfo',
}

export type User = {
  avatar_url: string;
  childrenData: {
    avatar_url: string;
    id: string;
    firstName: string;
    lastName: string;
  }[];
  id: number;
  complete: boolean;
  display_name: string;
  email: string;
  email_confirmed: boolean;
  role: number;
  userToken: string;
};

export const isBrowser = () => typeof window !== 'undefined';

const getCookie = (name: Cookie) => {
  if (isBrowser()) {
    const cookie = Cookies.get(name);

    if (cookie) {
      return JSON.parse(cookie);
    }
  }
};

export const getUser = () => getCookie(Cookie.user);

export const getSurveyInfo = () => getCookie(Cookie.surveyInfo);
export const setSurveyInfo = (surveyInfo: any) => {
  Cookies.set(Cookie.surveyInfo, JSON.stringify(surveyInfo));
};

export const setUser = (user: User) => {
  const domainParts = window.location.hostname.split('.');

  if (domainParts.length > 1) {
    Cookies.set(Cookie.user, JSON.stringify(user), {
      domain: `.${domainParts[domainParts.length - 2]}.${
        domainParts[domainParts.length - 1]
      }`,
    });
  } else {
    // for local dev cookie setting
    Cookies.set(Cookie.user, JSON.stringify(user));
  }
};

export const setContentfull = (lang, content) => {
  const domainParts = window.location.hostname.split('.');

  if (domainParts.length > 1) {
    Cookies.set('cf_' + lang, JSON.stringify(content), {
      domain: `.${domainParts[domainParts.length - 2]}.${
        domainParts[domainParts.length - 1]
      }`,
    });
  } else {
    // for local dev cookie setting
    Cookies.set(Cookie.user, JSON.stringify(content));
  }
};

export const setGoogleToken = (tokenObject: any) => {
  Cookies.set(Cookie.google, JSON.stringify(tokenObject));
};

export const getGoogleToken = () => getCookie(Cookie.google);

export const removeGoogleToken = () => {
  Cookies.remove(Cookie.google);
};

export const isLoggedIn = () => {
  const user = getUser();
  return !!user?.userToken;
};

export const logout = (callback: () => void) => {
  Cookies.remove(Cookie.user);
  callback();
};
